import { useTranslation } from 'react-i18next';
import { Box, Container } from '@mui/material';
import { VideosContainer } from 'src/containers/videos';
import { Helmet } from 'react-helmet';
import useSettings from '../../hooks/useSettings';

const Videos = () => {
  const { t } = useTranslation();
  const { settings } = useSettings();
  return (
    <>
      <Helmet>
        <title>{t('videos.helmet')}</title>
      </Helmet>
      <Box
        sx={{
          backgroundColor: 'background.default',
          minHeight: '100%',
          py: 4
        }}
      >
        <Container maxWidth={settings.compact ? 'xxl' : false}>
          <Box sx={{ mt: 3 }}>
            <VideosContainer />
          </Box>
        </Container>
      </Box>
    </>
  );
};

export default Videos;
